module.exports = __webpack_public_path__ + "media/images/login-graphic-303bb53da945f07412e83bde387aed2d.svg";